import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/button';
import { pricingPlans } from '../mock';

const PricingSection = ({ onGetStarted }) => {
  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Choose Your Perfect Plan
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Select the package that best fits your trademark protection needs. All plans include expert support.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {pricingPlans.map((plan) => (
            <div
              key={plan.id}
              className={`bg-white rounded-lg p-6 shadow-lg transition-all hover:shadow-xl flex flex-col ${
                plan.recommended ? 'ring-2 ring-blue-600 relative' : ''
              }`}
            >
              {plan.recommended && (
                <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                  <span className="bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                    Most Popular
                  </span>
                </div>
              )}

              <div className="text-center mb-6">
                <h3 className="text-xl font-bold text-gray-900 mb-2">{plan.name}</h3>
                <div className="mb-2">
                  <span className="text-3xl font-bold text-blue-600">{plan.price}</span>
                  <span className="text-sm text-gray-600">*</span>
                </div>
                <p className="text-sm text-gray-600">{plan.government_fee}</p>
              </div>

              <div className="flex-grow mb-6">
                <div className="max-h-64 overflow-y-auto">
                  <ul className="space-y-3">
                    {plan.features.map((feature, index) => (
                      <li key={index} className="flex items-start">
                        <Check className="h-5 w-5 text-green-500 mr-2 flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-700">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="text-xs text-gray-500 mb-4 text-center">{plan.note}</div>

              <Button
                onClick={onGetStarted}
                className={`w-full mt-auto ${
                  plan.recommended
                    ? 'bg-blue-600 hover:bg-blue-700'
                    : 'bg-gray-900 hover:bg-gray-800'
                } text-white`}
              >
                {plan.buttonText}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PricingSection;